import LogoDark from "../assets/images/logos/logo.png";
import { Link } from "react-router-dom";
import React from "react";

const Logo: React.FC = () => {
  return (
    // <Link to="/">
      <img src={LogoDark} alt="logo-image" style={{ width: 50 }}/>
    // </Link>
  );
};

export default Logo;
